// extracted by mini-css-extract-plugin
export default {"modalContentWrapper":"AcceptMarketingMessagesModal_modalContentWrapper__oDxBr"};